export default __webpack_public_path__ + "static/media/logotipo.528dfa75.svg";